import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setSkippedAd } from "../../../redux/slices/LcaSlice";
import axiosClient from "../../../axios-client";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const SkipModal = ({ open, close, ad }) => {
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [skipReason, setSkipReason] = useState(0);
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();
  const skipTypes = {
    1: "Customer Not Desired",
    2: "Already Booked on Date",
    3: "Other",
  };

  const handleSkipReasonChange = (e) => {
    const value = parseInt(e.target.value);
    setSkipReason(value);
    if (value !== 3) {
      setComment(""); // Reset comment if skip reason is not "Other"
    }
    if (value === 0) {
      setComment(""); // Reset comment if skip reason is not selected
    }
  };

  const handleConfirmSkip = async () => {
    if (!islogin) {
      toast.info("Please Login To Skip Customer!");
      return;
    }

    try {
      const formData = {
        needId: ad.Id,
        skipStatus: 1,
        createdBy: user?.UserID,
        skipReason: skipReason,
        comment: skipReason === 3 ? comment : undefined, // Include comment only if skipReason is "Other"
      };
      const response = await axiosClient.post("need/SkipCustomer", formData);
      if (response.data.statusCode === 200) {
        dispatch(
          setSkippedAd({
            ...ad,
            needSkipCustomer: 1,
          })
        );
        toast.success("Ad skipped successfully!");
        close();
      } else {
        toast.error(response.data.msg || "Failed to skip ad");
      }
    } catch (error) {
      toast.error("Error skipping ad");
      console.error("Error:", error);
    }
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleClose = () => {
    setSkipReason(0);
    setComment("");
    close();
  };

  // Determine if Skip button should be disabled
  const isSkipDisabled =
    skipReason === 0 || (skipReason === 3 && comment.trim() === "");

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Skip {ad.Title}</DialogTitle>
        <DialogContent>
          <div className="d-flex flex-column gap-2">
            <label htmlFor="skip-reason">
              Skip Reason <span style={{ color: "red" }}>*</span>
            </label>
            <select
              id="skip-reason"
              className="form-select"
              name="skipReason"
              value={skipReason}
              onChange={handleSkipReasonChange}
            >
              <option value={0} disabled>
                Select Reason
              </option>
              {Object.entries(skipTypes).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
            </select>

            {skipReason === 3 && (
              <div className="mt-3">
                <label htmlFor="comment">
                  Comment <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  id="comment"
                  className="form-control"
                  value={comment}
                  onChange={handleCommentChange}
                  placeholder="Enter your comment"
                  rows={4}
                />
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleConfirmSkip}
            disabled={isSkipDisabled}
            autoFocus
          >
            Skip
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default SkipModal;
